/**
 * PoolFilters Component - Phase 2C-2 (FIXED)
 * 
 * Filter controls for pool list.
 * 
 * FIXED: Removed unused Input import
 */

import { PoolFilters as PoolFiltersType, PoolDomain, PoolStatus, PoolMode } from '../../types';
import { Select, Button } from '../common';

interface PoolFiltersProps {
  filters: PoolFiltersType;
  onFiltersChange: (filters: PoolFiltersType) => void;
  className?: string;
}

export function PoolFilters({
  filters,
  onFiltersChange,
  className = '',
}: PoolFiltersProps): JSX.Element {
  const domainOptions = [
    { value: '', label: 'All Domains' },
    { value: 'nfl', label: 'NFL' },
    { value: 'nba', label: 'NBA' },
    { value: 'mlb', label: 'MLB' },
    { value: 'nhl', label: 'NHL' },
    { value: 'college', label: 'College' },
    { value: 'soccer', label: 'Soccer' },
    { value: 'corporate', label: 'Corporate' },
    { value: 'financial', label: 'Financial' },
  ];

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'pending', label: 'Pending' },
    { value: 'locked', label: 'Locked' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
  ];

  const modeOptions = [
    { value: '', label: 'All Modes' },
    { value: 'gm', label: 'GM Mode' },
    { value: 'pick', label: 'Pick Mode' },
  ];

  const handleDomainChange = (value: string) => {
    onFiltersChange({
      ...filters,
      domain: value ? (value as PoolDomain) : undefined,
    });
  };

  const handleStatusChange = (value: string) => {
    onFiltersChange({
      ...filters,
      status: value ? (value as PoolStatus) : undefined,
    });
  };

  const handleModeChange = (value: string) => {
    onFiltersChange({
      ...filters,
      mode: value ? (value as PoolMode) : undefined,
    });
  };

  const handleClearFilters = () => {
    onFiltersChange({});
  };

  const hasActiveFilters = filters.domain || filters.status || filters.mode;

  return (
    <div className={`flex flex-wrap items-center gap-4 ${className}`}>
      <Select
        value={filters.domain || ''}
        onChange={handleDomainChange}
        options={domainOptions}
      />
      
      <Select
        value={filters.status || ''}
        onChange={handleStatusChange}
        options={statusOptions}
      />
      
      <Select
        value={filters.mode || ''}
        onChange={handleModeChange}
        options={modeOptions}
      />

      {hasActiveFilters && (
        <Button variant="ghost" size="sm" onClick={handleClearFilters}>
          Clear Filters
        </Button>
      )}
    </div>
  );
}
